/**
 * Mobile Drawer - controle de estado, abertura/fechamento e navegação por painéis (drill-down)
 */
(function () {
  'use strict';

  const SELECTORS = {
    container: '[id="mobile-drawer-container"]',
    trigger: '[data-mobile-drawer-trigger]',
    overlay: '[data-mobile-drawer-overlay]',
    drawer: '[data-mobile-drawer]',
    close: '[data-mobile-drawer-close]',
    panelsWrapper: '[data-menu-panels]',
    panel: '.menu-panel',
    panelActive: '.menu-panel.is-active',
    openPanelBtn: '[data-action="open-panel"]',
    backBtn: '[data-action="back"]',
  };

  const PANEL_LEVEL_1_ID = 'menu-panel-level-1';

  function find(container, selector) {
    return container.querySelector(selector);
  }

  function findAll(container, selector) {
    return Array.from(container.querySelectorAll(selector));
  }

  function openDrawer(ctx) {
    if (!ctx.drawer || !ctx.overlay) return;
    ctx.drawer.setAttribute('data-open', 'true');
    ctx.drawer.style.transform = 'translateX(0)';
    ctx.drawer.setAttribute('aria-hidden', 'false');
    ctx.overlay.setAttribute('data-visible', 'true');
    ctx.overlay.setAttribute('aria-hidden', 'false');
    if (ctx.trigger) ctx.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-drawer-open');
    resetToRootPanel(ctx);
  }

  function closeDrawer(ctx) {
    if (!ctx.drawer) return;
    ctx.drawer.setAttribute('data-open', 'false');
    ctx.drawer.style.transform = 'translateX(-100%)';
    ctx.drawer.setAttribute('aria-hidden', 'true');
    if (ctx.overlay) {
      ctx.overlay.setAttribute('data-visible', 'false');
      ctx.overlay.setAttribute('aria-hidden', 'true');
    }
    if (ctx.trigger) ctx.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-drawer-open');
    resetToRootPanel(ctx);
  }

  function toggleDrawer(ctx) {
    const isOpen = ctx.drawer && ctx.drawer.getAttribute('data-open') === 'true';
    if (isOpen) closeDrawer(ctx);
    else openDrawer(ctx);
  }

  function getActivePanel(ctx) {
    if (!ctx.panelsWrapper) return null;
    return ctx.panelsWrapper.querySelector(SELECTORS.panelActive);
  }

  function setActivePanel(panel) {
    if (!panel) return;
    const wrapper = panel.closest(SELECTORS.panelsWrapper);
    if (!wrapper) return;
    findAll(wrapper, SELECTORS.panel).forEach(function (p) {
      p.classList.remove('is-active');
    });
    panel.classList.remove('is-left');
    panel.classList.add('is-active');
  }

  function resetToRootPanel(ctx) {
    if (!ctx.panelsWrapper) return;
    ctx.panelStack = [];
    findAll(ctx.panelsWrapper, SELECTORS.panel).forEach(function (p) {
      p.classList.remove('is-left');
    });
    const root = ctx.panelsWrapper.querySelector('#' + PANEL_LEVEL_1_ID);
    if (root) setActivePanel(root);
  }

  function openPanel(ctx, targetPanelId) {
    if (!ctx.panelsWrapper) return;
    const current = getActivePanel(ctx);
    const target = ctx.panelsWrapper.querySelector('#' + targetPanelId);
    if (!target) return;
    if (current) {
      current.classList.add('is-left');
      ctx.panelStack.push(current.id);
    }
    setActivePanel(target);
  }

  function backPanel(ctx) {
    if (ctx.panelStack.length === 0) return;
    const parentId = ctx.panelStack.pop();
    const parent = ctx.panelsWrapper.querySelector('#' + parentId);
    if (parent) setActivePanel(parent);
  }

  function bindDrawer(ctx) {
    if (ctx.trigger) {
      ctx.trigger.addEventListener('click', function () {
        toggleDrawer(ctx);
      });
    }
    findAll(ctx.container, SELECTORS.close).forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer(ctx);
      });
    });
    if (ctx.overlay) {
      ctx.overlay.addEventListener('click', function () {
        closeDrawer(ctx);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (ctx.drawer && ctx.drawer.getAttribute('data-open') === 'true') {
        if (ctx.panelStack && ctx.panelStack.length > 0) {
          backPanel(ctx);
        } else {
          closeDrawer(ctx);
          if (ctx.trigger) ctx.trigger.focus();
        }
      }
    });
  }

  function bindPanels(ctx) {
    if (!ctx.panelsWrapper) return;
    ctx.panelStack = [];

    ctx.panelsWrapper.addEventListener('click', function (e) {
      const openBtn = e.target.closest(SELECTORS.openPanelBtn);
      if (openBtn) {
        e.preventDefault();
        const targetId = openBtn.getAttribute('data-target-panel');
        if (targetId) openPanel(ctx, targetId);
        return;
      }
      const backBtnEl = e.target.closest(SELECTORS.backBtn);
      if (backBtnEl) {
        e.preventDefault();
        backPanel(ctx);
      }
    });
  }

  function init() {
    document.body.classList.remove('mobile-drawer-open');
    const containers = document.querySelectorAll(SELECTORS.container);
    containers.forEach(function (container) {
      const ctx = {
        container: container,
        trigger: find(container, SELECTORS.trigger),
        overlay: find(container, SELECTORS.overlay),
        drawer: find(container, SELECTORS.drawer),
        panelsWrapper: find(container, SELECTORS.panelsWrapper),
        panelStack: [],
      };
      if (!ctx.drawer) return;
      closeDrawer(ctx);
      bindDrawer(ctx);
      bindPanels(ctx);
      setTimeout(function () { closeDrawer(ctx); }, 0);
      setTimeout(function () { closeDrawer(ctx); }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.body.classList.remove('mobile-drawer-open');
      document.querySelectorAll(SELECTORS.container).forEach(function (container) {
        const drawer = container.querySelector(SELECTORS.drawer);
        const overlay = container.querySelector(SELECTORS.overlay);
        if (drawer) {
          drawer.setAttribute('data-open', 'false');
          drawer.style.transform = 'translateX(-100%)';
          drawer.setAttribute('aria-hidden', 'true');
        }
        if (overlay) {
          overlay.setAttribute('data-visible', 'false');
          overlay.setAttribute('aria-hidden', 'true');
          overlay.style.opacity = '0';
          overlay.style.visibility = 'hidden';
          overlay.style.pointerEvents = 'none';
        }
        var trigger = container.querySelector(SELECTORS.trigger);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
